import { createContext, FC, PropsWithChildren, useMemo } from 'react';

import { buildComponent } from '~/core/shared/utils/general';
import {
  TenantDocumentDetailsTabComponent,
  TenantDocumentDetailsView,
  TenantDocumentRouteProps,
} from '../../config';
import { DefinitionContext } from '../../contexts';
import { AdminApplicationProvider } from '../../contexts/AdminApplicationContext';
import { useMiddleOfficeConfig } from '../../contexts/middleOfficeConfig';
import { ApplicationLayout } from './Layout.component';

type DocumentDetailsViewContextType = {
  config: TenantDocumentDetailsView;
};

export const DocumentDetailsViewContext =
  createContext<DocumentDetailsViewContextType>(
    {} as DocumentDetailsViewContextType,
  );

export const DocumentDetails: FC<
  PropsWithChildren<TenantDocumentRouteProps>
> = ({ children, ...props }) => {
  const middleOfficeConfig = useMiddleOfficeConfig();
  const viewConfig = middleOfficeConfig.getViewConfig(
    props,
  ) as TenantDocumentDetailsView;
  const tabConfig = middleOfficeConfig.getDetailsViewTabConfig(props);

  let viewContent = children;

  if (!viewContent && tabConfig) {
    if (tabConfig.type === 'component') {
      const tabComponentConfig = tabConfig as TenantDocumentDetailsTabComponent;
      viewContent = buildComponent(tabComponentConfig, props);
    } else if (tabConfig.type === 'relation') {
      // @TODO
    }
  }

  const definitionContextValue = useMemo(
    () => ({
      definition:
        viewConfig.documentRouteProps?.tenantDocumentDefinition ||
        'definitionNotSet',
    }),
    [viewConfig.documentRouteProps?.tenantDocumentDefinition],
  );

  const documentListViewContextValue = useMemo(
    () => ({
      config: viewConfig,
    }),
    [viewConfig],
  );

  return (
    <AdminApplicationProvider>
      <DefinitionContext.Provider value={definitionContextValue}>
        <DocumentDetailsViewContext.Provider
          value={documentListViewContextValue}
        >
          <ApplicationLayout
            selectedTabNavItem={tabConfig?.key || ''}
            {...{
              ...(tabConfig?.contentBoxProps
                ? { contentBoxProps: tabConfig?.contentBoxProps }
                : {}),
            }}
          >
            {viewContent}
          </ApplicationLayout>
        </DocumentDetailsViewContext.Provider>
      </DefinitionContext.Provider>
    </AdminApplicationProvider>
  );
};
